import { useTranslation } from 'react-i18next'

import { AcknowledgeModal, Modal, ModalProps } from '@percent/lemonade'

type LogVolunteeringActivitySuccessModalProps = Pick<ModalProps, 'open'> & {
  onClose: VoidFunction
  onConfirm: VoidFunction
  title: string
  description: string
}

export function LogVolunteeringActivitySuccessModal({
  open,
  onClose,
  onConfirm,
  title,
  description
}: Readonly<LogVolunteeringActivitySuccessModalProps>) {
  const { t } = useTranslation()

  return (
    <Modal borderRadiiSize="xlarge" onClose={onClose} open={open}>
      <AcknowledgeModal
        handleClose={onConfirm}
        result="positive"
        buttonShape="oval"
        title={title}
        description={description}
        buttonText={t('workplace_giving.common.done')}
      />
    </Modal>
  )
}
